import * as R from 'remeda';
import { createSelector } from 'reselect';
import Types from 'Types';
import { timeUtility } from 'utility';

const domain = (state: Types.RootState) => state.page.realtime;

const selectedDay = createSelector(domain, (domain) => domain.selectedDay);

const selectedDayHours = createSelector(selectedDay, (selectedDay) => {
  const displayedHours: Time.Date[] = [];

  timeUtility.dayToHours({ day: selectedDay }).forEach((hour, index) => {
    if (index < 6) return;
    if (index > 18) return;
    displayedHours.push(hour);
  });

  return displayedHours;
});

export { selectedDay, selectedDayHours };
